module.exports = __webpack_public_path__ + "img/portugal-pregnancy-childbirth-and-the-puerperium-female.c5d98285.png";